module.exports = __webpack_public_path__ + "media/images/utees-logo-full-246a6ff8125c32899cfff6e25499a49d.svg";